import {defineComponent} from 'vue';

export default defineComponent({
    compatConfig: {
        MODE: 3,
    },
    name: 'KlDescriptionListRow',
    props: {
        label: { type: String, default: '' },
        modCollapse: { type: Boolean, default: false },
    },
    setup(props) {
    }
})
